<!--@format-->
<template>
    <div class="icons-widget blue-gradient-header">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Icon</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div class="icon-grid bordered-group">
                    <label class="group-title">Choose an Icon</label>
                    <component
                        :is="icon"
                        v-for="(icon, index) in listOfIcons"
                        :key="index"
                        :class="{ 'selected-background': icon === selectedIcon }"
                        :color="icon === selectedIcon ? selectedColor : defaultColor"
                        class="icon"
                        @click.native="selectIcon(icon)"
                    />
                </div>
                <div class="icon-color-wrapper bordered-group">
                    <label class="group-title">Choose Icon Color</label>
                    <span class="group-title">Choose Icon Color</span>
                    <div class="choose-icon-color">
                        <div class="app-input-wrapper">
                            <p class="app-input-title">Color</p>
                            <app-color-input v-model="iconColor.value" show-branding-colors />
                        </div>
                        <component
                            :is="selectedIcon"
                            :color="iconColor.value"
                            class="icon icon-color-changed"
                        />
                    </div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="back-button" @click="closeWidget"> Back </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="saveIcon">Save</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const AppColorSetting = () => import('@/components/common/app-color-setting');
const AppColorInput = () => import('@/components/common/app-color-input');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const A29TechTouchSvg = () => import('@/components/svg/grid/a29-techtouch-svg');
const B29BinarySvg = () => import('@/components/svg/grid/b29-binary-svg');
const C29VirtualizationSvg = () => import('@/components/svg/grid/c29-virtualization-svg');
const D29GroupFilesSvg = () => import('@/components/svg/grid/d29-groupfiles-svg');
const E29MeshSvg = () => import('@/components/svg/grid/e29-mesh-svg');

const Q29ConnectionSvg = () => import('@/components/svg/grid/q29-connection-svg');
const S29ArchiveSvg = () => import('@/components/svg/grid/s29-archive-svg');
const R3024HourSvg = () => import('@/components/svg/grid/r30-24hour-svg');
const E29SupportSvg = () => import('@/components/svg/grid/e29-support-svg');
const G29AgentSvg = () => import('@/components/svg/grid/g29-agent-svg');
const Hf2SupportSvg = () => import('@/components/svg/grid/hf2-support-svg');
const O29CustomerassistanceSvg = () => import('@/components/svg/grid/o29-customer-assistance-svg');
const P29TicketSvg = () => import('@/components/svg/grid/p29-ticket-svg');
const N29ChatSvg = () => import('@/components/svg/grid/n29-chat-svg');
const T28AssistantSvg = () => import('@/components/svg/grid/t28-assistance-svg');
const B30MspSupportSvg = () => import('@/components/svg/grid/b30-msp-support-svg');

const R29SyncSvg = () => import('@/components/svg/grid/r29-sync-svg');
const I2SearchCloudSvg = () => import('@/components/svg/grid/i2-search-cloud-svg');
const K29CloudSecuritySvg = () => import('@/components/svg/grid/k29-cloud-security-svg');
const L29CloudServerSvg = () => import('@/components/svg/grid/l29-cloud-server-svg');
const M29CloudSecuritySvg = () => import('@/components/svg/grid/m29-cloud-security-svg');
const J2SearchCloudSvg = () => import('@/components/svg/grid/j2-search-cloud-svg');
const U28ThreatSvg = () => import('@/components/svg/grid/u28-threat-svg');
const T30VirusProtectionSvg = () => import('@/components/svg/grid/t30-virus-protection-svg');
const F30LockedLaptopSvg = () => import('@/components/svg/grid/f30-locked-laptop-svg');
const G30LockedFileSvg = () => import('@/components/svg/grid/g30-locked-file-svg');
const H30SecuredLaptopSvg = () => import('@/components/svg/grid/h30-secured-laptop-svg');
const M30ServerSvg = () => import('@/components/svg/grid/m30-server-svg');
const N30LockedPhoneSvg = () => import('@/components/svg/grid/n30-locked-phone-svg');
const O30SecuredFileSvg = () => import('@/components/svg/grid/o30-secured-file-svg');
const P30SecuredWebSvg = () => import('@/components/svg/grid/p30-secured-web-svg');
const Q30LockedArchives = () => import('@/components/svg/grid/q30-locked-archives');
const S30CpuSvg = () => import('@/components/svg/grid/s30-cpu-svg');
const I30HeadsetSvg = () => import('@/components/svg/grid/i30-headset-svg');
const J30VoipPhoneSvg = () => import('@/components/svg/grid/j30-voip-phone-svg');
const E31ComputerSvg = () => import('@/components/svg/grid/e31-computer-svg');
const A30FloatSvg = () => import('@/components/svg/grid/a30-float-svg');
const L30StrategySvg = () => import('@/components/svg/grid/l30-strategy-svg');
const D30ShapesSvg = () => import('@/components/svg/grid/d30-shapes-svg');
const E30IncreasingSvg = () => import('@/components/svg/grid/e30-increasing-svg');
const K30OptionsSvg = () => import('@/components/svg/grid/k30-options-svg');
const A31CloudSettingsSvg = () => import('@/components/svg/grid/a31-cloud-settings-svg');
const B31OptimizationSvg = () => import('@/components/svg/grid/b31-optimization-svg');
const C31StrategyTalkSvg = () => import('@/components/svg/grid/c31-strategy-talk-svg');
const D31StrategicThinkingSvg = () => import('@/components/svg/grid/d31-strategic-thinking-svg');
const U30ShakingHandsGearSvg = () => import('@/components/svg/grid/u30-shaking-hands-gear-svg');
const C30TimeSupportSvg = () => import('@/components/svg/grid/c30-time-support-svg');
const F31PhishingSvg = () => import('@/components/svg/grid/f31-phishing-svg');

import EventBus from '@/scripts/event-bus.js';
import DocumentBuilderMixin from '@/mixins/builder/document-builder-mixin';
import BrandingMixin from '@/mixins/branding-mixin';

export default {
    name: 'icons-widget',

    components: {
        'app-button': AppButton,
        'app-color-setting': AppColorSetting,
        'app-color-input': AppColorInput,
        'loading-screen-svg': LoadingScreenSvg,
        'widget-close-svg': WidgetCloseSvg,
        'a29-techtouch-svg': A29TechTouchSvg,
        'b29-binary-svg': B29BinarySvg,
        'c29-virtualization-svg': C29VirtualizationSvg,
        'd29-groupfiles-svg': D29GroupFilesSvg,
        'e29-mesh-svg': E29MeshSvg,

        'q29-connection-svg': Q29ConnectionSvg,
        's29-archive-svg': S29ArchiveSvg,
        'r30-24hour-svg': R3024HourSvg,
        'e29-support-svg': E29SupportSvg,
        'g29-agent-svg': G29AgentSvg,
        'hf2-support-svg': Hf2SupportSvg,
        'n29-chat-svg': N29ChatSvg,
        'o29-customer-assistance-svg': O29CustomerassistanceSvg,
        'p29-ticket-svg': P29TicketSvg,
        't28-assistance-svg': T28AssistantSvg,
        'b30-msp-support-svg': B30MspSupportSvg,

        'r29-sync-svg': R29SyncSvg,
        'i2-search-cloud-svg': I2SearchCloudSvg,
        'k29-cloud-security-svg': K29CloudSecuritySvg,
        'l29-cloud-server-svg': L29CloudServerSvg,
        'm29-cloud-security-svg': M29CloudSecuritySvg,
        'j2-search-cloud-svg': J2SearchCloudSvg,
        'u28-threat-svg': U28ThreatSvg,
        't30-virus-protection-svg': T30VirusProtectionSvg,
        'f30-locked-laptop-svg': F30LockedLaptopSvg,
        'g30-locked-file-svg': G30LockedFileSvg,
        'h30-secured-laptop-svg': H30SecuredLaptopSvg,
        'm30-server-svg': M30ServerSvg,
        'n30-locked-phone-svg': N30LockedPhoneSvg,
        'o30-secured-file-svg': O30SecuredFileSvg,
        'p30-secured-web-svg': P30SecuredWebSvg,
        'q30-locked-archives': Q30LockedArchives,
        's30-cpu-svg': S30CpuSvg,
        'i30-headset-svg': I30HeadsetSvg,
        'j30-voip-phone-svg': J30VoipPhoneSvg,
        'e31-computer-svg': E31ComputerSvg,
        'a30-float-svg': A30FloatSvg,
        'l30-strategy-svg': L30StrategySvg,
        'd30-shapes-svg': D30ShapesSvg,
        'e30-increasing-svg': E30IncreasingSvg,
        'k30-options-svg': K30OptionsSvg,
        'a31-cloud-settings-svg': A31CloudSettingsSvg,
        'b31-optimization-svg': B31OptimizationSvg,
        'c31-strategy-talk-svg': C31StrategyTalkSvg,
        'd31-strategic-thinking-svg': D31StrategicThinkingSvg,
        'u30-shaking-hands-gear-svg': U30ShakingHandsGearSvg,
        'c30-time-support-svg': C30TimeSupportSvg,
        'f31-phishing-svg': F31PhishingSvg,
    },

    mixins: [DocumentBuilderMixin, BrandingMixin],

    provide() {
        return {
            $brandingColors: () => this.brandingColors,
        };
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            defaultColor: '#382153',
            selectedColor: '#FFFFFF',
            selectedIcon: 'a29-techtouch-svg',
            iconColor: {
                value: '#F30070',
            },

            listOfIcons: [
                'a29-techtouch-svg',
                'b29-binary-svg',
                'c29-virtualization-svg',
                'd29-groupfiles-svg',
                'e29-mesh-svg',
                'q29-connection-svg',
                's29-archive-svg',
                'r30-24hour-svg',
                'e29-support-svg',
                'g29-agent-svg',
                'hf2-support-svg',
                'n29-chat-svg',
                'o29-customer-assistance-svg',
                'p29-ticket-svg',
                't28-assistance-svg',
                'b30-msp-support-svg',

                'r29-sync-svg',
                'i2-search-cloud-svg',
                'k29-cloud-security-svg',
                'l29-cloud-server-svg',
                'm29-cloud-security-svg',
                'j2-search-cloud-svg',
                'u28-threat-svg',
                't30-virus-protection-svg',
                'f30-locked-laptop-svg',
                'g30-locked-file-svg',
                'h30-secured-laptop-svg',
                'm30-server-svg',
                'n30-locked-phone-svg',
                'o30-secured-file-svg',
                'p30-secured-web-svg',
                'q30-locked-archives',
                's30-cpu-svg',
                'i30-headset-svg',
                'j30-voip-phone-svg',
                'e31-computer-svg',
                'a30-float-svg',
                'l30-strategy-svg',
                'd30-shapes-svg',
                'e30-increasing-svg',
                'k30-options-svg',
                'a31-cloud-settings-svg',
                'b31-optimization-svg',
                'c31-strategy-talk-svg',
                'd31-strategic-thinking-svg',
                'u30-shaking-hands-gear-svg',
                'c30-time-support-svg',
                'f31-phishing-svg',
            ],
        };
    },

    computed: {
        brandingColors() {
            return this.brandingContext.brandingOptions;
        },
    },

    created() {
        this.getBranding();
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        selectIcon(icon) {
            this.selectedIcon = icon;
        },

        saveIcon() {
            this.getISvgBase64Url();
        },

        getISvgBase64Url() {
            const svgContent = document.querySelector('.icon-color-changed');
            const canvas = document.createElement('canvas');
            var svgImage = document.createElement('img');

            svgImage.style.width = svgContent.style.width;
            svgImage.style.height = svgContent.style.height;

            svgImage.src = 'data:image/svg+xml;base64,' + window.btoa(svgContent.outerHTML);
            canvas.getContext('2d').drawImage(svgImage, 0, 0);

            EventBus.$emit('icon:select', { name: this.selectedIcon, url: svgImage.src });
            this.closeWidget();
        },
    },
};
</script>

<style>
.icons-widget .content-wrapper .icon-grid {
    padding: 24px;
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 24px;
}

.icons-widget .content-wrapper .icon-grid svg {
    background: transparent;
    border-radius: 8px;
    height: 40px;
    width: 40px;
}

.icons-widget .content-wrapper .icon-grid .selected-background.icon {
    background: #18aeff;
}

.icons-widget .content-wrapper .icon-grid svg:hover {
    background: #e9e9ef;
}

.icons-widget .content-wrapper .icon-color-wrapper {
    padding: 40px 82px;
}

.icons-widget .content-wrapper .icon-color-wrapper .app-input-wrapper .app-input-title {
    font: normal normal normal 12px/11px Roboto;
}

.icons-widget .content-wrapper .icon-color-wrapper .choose-icon-color {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 32px;
}

.icons-widget .content-wrapper .icon-color-wrapper .choose-icon-color svg {
    border: 1px solid #cac6cb;
    border-radius: 16px;
    height: 64px;
    width: 64px;
}

.icons-widget
    .content-wrapper
    .icon-color-wrapper
    .choose-icon-color
    .app-color-input
    .color-selector-input {
    min-width: 50px;
}

.icons-widget
    .content-wrapper
    .icon-color-wrapper
    .choose-icon-color
    .app-color-input
    .app-input
    input {
    padding: 5px 15px;
    font: normal normal normal 14px/11px Roboto;
}

.icons-widget .content-wrapper .icon-grid.bordered-group .group-title {
    width: 171px;
}

.icons-widget .content-wrapper .icon-color-wrapper.bordered-group .group-title {
    width: 192px;
}

.icons-widget .content-wrapper .bordered-group {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #cac6cb;
    border-radius: 16px;
    position: relative;
}

.icons-widget .content-wrapper .bordered-group .group-title {
    text-align: center;
    font: normal normal 16px/11px Roboto;
    font-weight: 500;
    letter-spacing: 0px;
}

.icons-widget .content-wrapper .bordered-group label.group-title {
    position: absolute;
    top: -18px;
    left: calc(50% - 100px);
    background: #ffffff;
    display: block;
    padding: 11px 30px;
    margin: 0;
    color: #382153;
}

.icons-widget .widget-footer .app-button.back-button {
    width: 127px;
}

.icons-widget .widget-footer .action-container .app-button {
    width: 152px;
}
</style>
